// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"SectionTitle_titleContainer__h2Yio","titleText":"SectionTitle_titleText__dXAqt"};